import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { getAllBrandsData } from '../../../actions';
import { MY_ACCOUNT } from '../../../constants';

import FigoLottie from '../../common/FigoLottie';
import MultiPoliciesPayments from './MultiPoliciesPayments';
import {
  BillingDetailsScreen,
} from './BillingAndPaymentsDetails/BillingDetailsScreen';
import { EmptyScreen } from '../../common/petCloud/EmptyScreen';

import './css/BillingAndPaymentsScreen.css';
import { useRecaptchaValidator } from '../../../hooks/useRecaptchaValidator';
import { useRecaptcha } from '../../../hooks';

const BillingAndPaymentsScreen = ({ breadCrumbs, currentFolderId }) => {
  const { t } = useTranslation('myAccount');
  const dispatch = useDispatch();
  const store = useSelector(({ billingPayments }) => ({ billingPayments }),
    shallowEqual);

  const needRecaptcha = useRecaptcha();
  const { recaptchaValidate } = useRecaptchaValidator();

  const isBillingDetails = React.useMemo(() => (currentFolderId
    === MY_ACCOUNT.billingAndPaymentDetails), [currentFolderId]);

  useEffect(() => {
    if (!isBillingDetails) {
      dispatch(getAllBrandsData());
    }
  }, [isBillingDetails]);

  const { allBrandsData, loadingAllBrandsData } = store.billingPayments;

  function renderContent() {
    // verifying site
    if (needRecaptcha && !recaptchaValidate) {
      return <FigoLottie />;
    }

    // billing details, not general billing and payments screen
    if (isBillingDetails) {
      return <BillingDetailsScreen breadCrumbs={breadCrumbs} />;
    }

    // loading state
    if (loadingAllBrandsData) {
      return <FigoLottie />;
    }

    // empty policy summary response/no policies
    if (allBrandsData.length === 0) {
      return (
        <EmptyScreen
          description={t('billingAndPayments'
            + '.noCurrentPolicyPaymentsDescription')}
          title={t('billingAndPayments.noCurrentPolicyPaymentsTitle')}
        />
      );
    }

    return (
      <>
        <p className="Billing-and-payments-description">
          {t('billingAndPayments.description')}
        </p>

        <MultiPoliciesPayments
          allBrandsData={allBrandsData}
          breadCrumbs={breadCrumbs}
        />
      </>
    );
  }

  return (
    <div className="Billing-and-payments-container">
      <h1 className="Billing-and-payments-title">
        {t('billingDetailsCard.title')}
      </h1>

      {renderContent()}
    </div>
  );
};

export { BillingAndPaymentsScreen };
